// extracted by mini-css-extract-plugin
export default {"button":"Button_button__UFKeA","button_secondary":"Button_button_secondary__oJsaI","button_withIcon":"Button_button_withIcon__RPePC"};